import Splide from '@splidejs/splide';

export class HomeCarousels {
    homeCarouselContainers: HTMLElement;
    triggers: HTMLElement[];

    constructor(homeCarouselContainers: HTMLElement) {
        const textSplide = homeCarouselContainers.querySelector('[data-homecarousel-text-splide]') as HTMLElement;
        
        var textSlider = new Splide(textSplide, {
            accessibility: true,
            pagination: false,
            // @ts-ignore
            slideFocus: false,
            arrows: true,
            loop: true,
            drag: true,
        }).mount();

        // Call updateHomeCarouselHeight() as soon as possible to avoid content layout shift
        this.updateHomeCarouselHeight();

        this.updateActiveOnClick(textSlider);

        // Call updateHomeCarouselHeight() again
        //  Just in case the carousel wasn't fully loaded when we first called it
        textSlider.on('ready', () => {
            this.updateHomeCarouselHeight();
        });

        textSlider.on('resized', () => {
            this.updateHomeCarouselHeight();
        });
    }

    updateSlideIndex(slider) {
        const currentIndex = slider.index;
        slider.go(currentIndex)
    }

    updateActiveOnClick(slider) {
        slider.Components.Elements.slides.forEach((slide, index) => {
            slide.addEventListener("click", () => {
                slider.go(index);
            })
        })
    }

    updateHomeCarouselHeight() {
        const items = document.querySelectorAll('.homecarousel-secondary-content') as NodeListOf<HTMLElement>;
        const carouselBtns = document.querySelector('.homecarousel-container .btn-arrows') as HTMLElement;

        document.documentElement.style.removeProperty('--homecarousel-height');

        let maxHeight = 0;
      
        items.forEach(item => {
            const height = item.getBoundingClientRect().height;

            if (height > maxHeight) {
                maxHeight = height;
            }
        });
      
        if (maxHeight > 0) {
            document.documentElement.style.setProperty('--homecarousel-height', `${maxHeight}px`);
        }

        if (carouselBtns) {
            carouselBtns.style.visibility = 'visible';
        }
    }
}